import './App.css';
// router
import { BrowserRouter, Routes, Route } from "react-router-dom";

// protected routes
import AuthRoute from './components/ProtectedRoute/AuthRoute';

// base url
import { BaseUrl } from './utils/BaseApi';

// screens components
import Login from "./screens/Login"; 
import Student from "./screens/Student";

import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getStudentData } from './redux/actions/AuthActions';


function App() {
  const dispatch =  useDispatch()

  // setting base url
  axios.defaults.baseURL = BaseUrl

  useEffect(()=>{
    dispatch(getStudentData())
  }, [dispatch])
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Student />} />
          <Route path="/login" element={<AuthRoute component={Login} />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
